import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useSearchParams, useNavigate } from 'react-router-dom';
import SimulateurTarif from '../components/SimulateurTarif';
import BackButton from '../components/BackButton';
import { toast } from 'sonner';

export default function SimulateurTarification() {
  const { getAuthHeader, user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  // Détecter si on doit ouvrir en mode avenant
  const initialMode = searchParams.get('mode') === 'avenant' ? 'avenant' : 'souscription';

  const handleAvenantCreated = (avenant) => {
    toast.success(`Avenant ${avenant?.reference} créé !`);
    // Rediriger vers le dashboard approprié selon le rôle
    if (user?.role === 'member' || user?.role === 'membre') {
      navigate('/member');
    } else if (user?.role === 'cooper') {
      navigate('/cooper');
    } else if (user?.role === 'super_admin' || user?.role === 'admin') {
      navigate('/admin/super-dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        {/* Header avec retour */}
        <div className="mb-6">
          <BackButton homeLabel="Cockpit BATICO / RCDS" />
        </div>
        
        {/* Simulateur */}
        <SimulateurTarif 
          getAuthHeader={getAuthHeader}
          onAvenantCreated={handleAvenantCreated}
          initialMode={initialMode}
        />
      </div>
    </div>
  );
}
